import { observable, action, runInAction, computed} from 'mobx'
import { message } from 'antd'
import { json } from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";

class hoursContentManagerStore {

    @observable loading
    @observable carseries
    @observable carSysId
    @observable directory
    @observable contents
    @observable directoryId
    @observable modal
    @observable form
    @observable imgUrl
    @observable data
    @observable stepModal
    @observable stepList
    @observable rowData

    constructor() {
        this.loading = false
        this.carseries = []
        this.carSysId = ''
        this.directory = []
        this.contents = []
        this.directoryId = ''
        this.modal = 'hide'
        this.form = {}
        this.imgUrl = ''
        this.data = ''
        this.stepModal = 'hide'
        this.stepList = []
        this.rowData = {}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 初始化车系
     */
    @action
    initCarseries = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/list`,{
            size:100
        })
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.carseries = res.content
            this.loading = false
        })
    }

    /**
     * 取车系ID
     */
    @action
    getCarSysId = (value) =>{
        runInAction(()=>{
            this.carSysId = value;
        })
    }

    /**
     * 目录树
     */
    @action
    initDirectory = async (value) => {
        runInAction(() => {
            this.contents = []
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/list?carseriesId=${value}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.directory = [];
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.directory = res
            this.loading = false
        })
    }

    /**
     * 获取到目录树ID
     */
    @action
    stlcontent = (directoryId) =>{
        runInAction(() => {
            this.directoryId = directoryId
        })
    }

    /**
     * 显示内容
     */
    @action
    loadContents = async () => {
        runInAction(() => {
            this.loading = true
            this.contents = []
        })
        const res2 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/selectLevel?id=${this.directoryId}`)
        if (res2.status && res2.status === 0) {
            return
        }
        runInAction(() => {
            this.data = res2.data
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/list?catalogId=${this.directoryId}`)
        if (res && res.status === 0) {
            return
        }
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/contentImg/catalogId/${this.directoryId}`)
        runInAction(() => {
            this.contents = res
            this.imgUrl = res1.image
            this.loading = false
        })
    }

    /**
     * 显示和关闭form编辑框
     */
    @action
    showModal = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modal = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.form.id},
            name: {value: this.form.name},
            timeCodeComplete: {value: this.form.timeCodeComplete},
            timeCodeSupplement: {value: this.form.timeCodeSupplement},
            sparePartsGrouping: {value: this.form.sparePartsGrouping},
            manHour: {value: this.form.manHour},
            note: {value: this.form.note}
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let form = {
            id: fields.id.value,
            name: fields.name.value,
            timeCodeComplete: fields.timeCodeComplete.value,
            timeCodeSupplement: fields.timeCodeSupplement.value,
            sparePartsGrouping: fields.sparePartsGrouping.value,
            manHour: fields.manHour.value,
            note: fields.note.value
        }
        this.form = form
    }

    /**
     * 新增内容 + 修改内容
     */
    @action
    saveContent = async () => {
        runInAction(() => {
            this.loading = true
        })
        let data = {
            name: this.form.name,
            timeCodeComplete: this.form.timeCodeComplete,
            timeCodeSupplement: this.form.timeCodeSupplement,
            sparePartsGrouping: this.form.sparePartsGrouping,
            manHour: this.form.manHour,
            note: this.form.note,
            catalogId: this.directoryId
        }
        if (!this.form.id) {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/create`, data)
            if (res && res.status >= 400) {
                message.error('新增失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('保存内容成功')
                    this.form = {}
                    this.loading = false
                })
                await this.loadContents(this.directoryId)
            }
        }else {
            const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/update`, {
                ...this.form
            })
            if (res && res.status >= 400) {
                message.error('修改新增失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('修改内容成功')
                    this.form = {}
                    this.loading = false
                })
                await this.loadContents(this.directoryId)
            }
        }
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action
    initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.form = res
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 图片上传
     */
    @action
    imageUpload = (info) => {
        this.imgUrl = info.file.response
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            let data = {
                catalogId : this.directoryId,
                image : info
            }
            const res = json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/contentImg/create`, data)
            if (res && res.status >= 400) {
                message.error('新增失败')
                return
            }
            runInAction(() => {
                this.loading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.loading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 上移
     */
    @action
    shiftUp = async(id) => {
        runInAction(() => {
            this.loading = true
        })
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/shiftUp?catalogId=${this.directoryId}&id=${id}`)
        runInAction(() => {
            this.loading = false
        })
        await this.loadContents(this.directoryId)
    }

    /**
     * 下移
     */
    @action
    moveDown = async(id) => {
        runInAction(() => {
            this.loading = true
        })
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/moveDown?catalogId=${this.directoryId}&id=${id}`)
        runInAction(() => {
            this.loading = false
        })
        await this.loadContents(this.directoryId)
    }

    /**
     * 刪除
     */
    @action
    deleteContent = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/delete?id=${id}`)
        if (res && res.status >= 400) {
            return
        }
        runInAction(() => {
            message.success('删除成功')
            this.loading = false
        })
        await this.loadContents(this.directoryId)
    }

    /**
     * 初始化页面
     */
    @action
    emptyPage = () =>{
        runInAction(() => {
            this.contents = []
            this.directory = []
            this.data = ''
        })
    }

    /**
     * 工时编码查询步骤列表
     */
    @action
    clickTimeCode = async(record) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/step/timeCodeQueryList?timeCode=${record}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.stepList = res
            this.stepModal = 'show'
            this.loading = false
        })
    }

    /**
     *取消步骤列表
     */
    @action
    cancelStepEdit () {
        this.stepModal = 'hide'
    }

    /***
     * 保存排序
     * @returns {Promise<void>}
     */
    @action
    saveSort=async ()=>{
        let contents = []
        this.contents.forEach((item, index) => {
            contents.push({
                id: item.id,
                sort: index + 1
            })
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/modifySort`,contents)
        if (res.status) {
            message.success(`排序成功！`)
        }
    }
}
export default new hoursContentManagerStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/HoursManual/HoursContentManager/store.js